module.exports = __webpack_public_path__ + "img/gold-3.92b7af46.png";